import { render, staticRenderFns } from "./mergeTab.vue?vue&type=template&id=a7863566&scoped=true&"
import script from "./mergeTab.vue?vue&type=script&lang=js&"
export * from "./mergeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7863566",
  null
  
)

export default component.exports